import { useState, MouseEvent } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export interface ActionsMenuItem {
  label: string;
  onClick: () => void;
  danger?: boolean;
}

export interface ActionsMenuProps {
  items: ActionsMenuItem[];
  ariaLabel?: string;
}

export function ActionsMenu({ items, ariaLabel = 'more actions' }: ActionsMenuProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = (e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const close = () => setAnchorEl(null);

  return (
    <>
      <IconButton size="small" aria-label={ariaLabel} onClick={open}>
        <MoreHorizIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={close}
        // borderRadius/boxShadow come from the theme's MuiMenu.paper override
        // (ported from ComplyControl's adminPanelTheme.ts).
        PaperProps={{ sx: { minWidth: 160 } }}
      >
        {items.map((item) => (
          <MenuItem
            key={item.label}
            onClick={() => {
              close();
              item.onClick();
            }}
            sx={{ fontSize: 14, ...(item.danger && { color: 'error.main' }) }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
